// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag-3VPhP","CrossIconContainer":"CrossIconContainer-1moap","CrossIcon":"CrossIcon-273YI"};